import {useEffect, useState} from "react";
import Loading from "../../component/Loading/Loading";
import {
    getAllProducts,
    getColors,
    getSizes,
    isSellable,
    minmaxPrice, printInstallmentConditions,
    printPrice
} from "./functions";
import placeholderImage from "../../assets/placeholderImage.jpg";
import {baseImagesUrl} from "../../assets/Constants";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faImages, faPencil, faTrash} from "@fortawesome/free-solid-svg-icons";
import {Link, useLocation, useSearchParams} from "react-router-dom";
import FilterForm from "./component/FilterForm/FilterForm";
import Pagination from "../../component/Pagination/Pagination";

const Products = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [allProductsData, setAllProductsData] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const location = useLocation();


    useEffect(() => {
        document.title = "مدیریت محصولات";
    }, []);


    useEffect(() => {
        (async () => {
            setIsLoading(true);
            const productData = await getAllProducts(location.search);
            console.log(productData);
            setAllProductsData(productData);
            setIsLoading(false);
        })();
    }, [searchParams]);


    return (
        <div className="container-fluid p-0">
            <div className="mb-4">
                <h1 className="h3 d-inline align-middle">مدیریت محصولات</h1>
            </div>


            <FilterForm searchParams={Object.fromEntries([...searchParams])} onSubmit={async (value) => {
                const newSearchParams = {...Object.fromEntries([...searchParams])  , ...value , page : 1 };
                setSearchParams(newSearchParams)
            }} />

            {isLoading && <Loading/>}

            {
                !isLoading && allProductsData.itemCount > 0 && <div className={"alert alert-info text-center"}>{allProductsData.itemCount} کالا یافت شد!</div>
            }
            {
                !isLoading && allProductsData.itemCount == 0 && <div className={"alert alert-warning text-center"}>کالایی با این مشخصات یافت نشد!</div>
            }


            {
                !isLoading && allProductsData.products.map((product) => {
                    return (
                        <div key={product.id} className="card">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-2">
                                        <span className="badge bg-secondary position-absolute top-0">
                                            {product.pictures.length}
                                            <FontAwesomeIcon width={15} icon={faImages}/>
                                        </span>
                                        <img className={"w-100"}
                                             src={product.primaryPicture ? `${baseImagesUrl}product/${product.primaryPicture}` : placeholderImage}/>
                                    </div>

                                    <div className="col-md-4">
                                        <h6 className={"mb-2"}>{product.persianTitle}</h6>

                                        <table className={"table table-bordered text-center"}>
                                            <thead>
                                            <tr>
                                                {getColors(product.singleProducts).length > 0 && <td>رنگ</td>}
                                                {getSizes(product.singleProducts).length > 0 && <td>سایز</td>}
                                                <td>موجودی</td>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {
                                                product.singleProducts.map((singleProduct, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            {singleProduct.color && <td>{singleProduct.color}</td>}
                                                            {singleProduct.size && <td>{singleProduct.size}</td>}
                                                            <td>{singleProduct.balance ||
                                                                <span className={"text-danger"}>ناموجود</span>}</td>
                                                        </tr>
                                                    );
                                                })
                                            }

                                            </tbody>
                                        </table>
                                    </div>


                                    <div className="col-md-6">
                                        {
                                            product.productCategory.map((pc, i) => {

                                                const html = pc.parents.reverse().map((parent, index) => {
                                                        return (<span key={index}>{parent.category.persianName} » </span>)
                                                    }
                                                )

                                                return <p key={i}><span>{html} {pc.category.persianName}</span></p>
                                            })

                                        }
                                        {
                                            isSellable(product.sellingTypeId) && product.currency &&
                                            <table className={"table table-bordered table-hover text-center"}>
                                                <thead>
                                                <tr>
                                                    <th>کاربر عادی</th>
                                                    <th>کاربر نقره ای</th>
                                                    <th>کاربر طلایی</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr>
                                                    <td>
                                                        {printPrice(minmaxPrice(product.singleProducts, "normal"), product.currency.rate)}
                                                    </td>
                                                    <td>
                                                        {printPrice(minmaxPrice(product.singleProducts, "silver"), product.currency.rate)}
                                                    </td>
                                                    <td>
                                                        {printPrice(minmaxPrice(product.singleProducts, "gold"), product.currency.rate)}
                                                    </td>
                                                </tr>
                                                {product.currency.id != 1 && <tr>
                                                    <td colSpan={3} className={"small"}>قیمت گذاری بر
                                                        اساس {product.currency.name}</td>
                                                </tr>
                                                }
                                                <tr>
                                                    <td>
                                                        {printInstallmentConditions(product.singleProducts[0].productPrices.normalInstallment)}
                                                    </td>
                                                    <td>
                                                        {printInstallmentConditions(product.singleProducts[0].productPrices.silverInstallment)}
                                                    </td>
                                                    <td>
                                                        {printInstallmentConditions(product.singleProducts[0].productPrices.goldInstallment)}
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        }

                                        {
                                            !isSellable(product.sellingTypeId) && <div
                                                className={`text-center alert ${product.sellingTypeId == 6 ? "alert-danger" : "alert-info"}`}>
                                            {product.sellingType.type.persianLabel}
                                            </div>
                                        }

                                        <div className="buttons position-absolute" style={{left: '5px', top: '5px'}}>
                                            <Link to={`./update/${product.id}`} type={"button"}
                                                  className={"btn btn-secondary"}>
                                                <FontAwesomeIcon icon={faPencil}/></Link>

                                            <button type={"button"} className={"btn btn-danger me-2"}>
                                                <FontAwesomeIcon icon={faTrash}/></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })
            }

            <Pagination pageCount={allProductsData.pageCount} currentPage={Object.fromEntries([...searchParams]).page } onChange={async (value) => {
                const newSearchParams = {...Object.fromEntries([...searchParams]) , page : value};
                setSearchParams(newSearchParams)

            }} />

        </div>
    );
};

export default Products;